// hooks/useFetch.ts
import { useState, useEffect } from "react";

/**
 * useFetch é um hook genérico para requisições GET.
 * @param shouldFetch - booleano: decide se a chamada deve acontecer.
 * @param serviceFn - função que faz a requisição e retorna uma Promise<T>.
 * @param deps - array de dependências do useEffect.
 * @param args - argumentos adicionais para passar à serviceFn.
 */
export function useFetch<T>(
  shouldFetch: boolean,
  serviceFn: (...args: any[]) => Promise<T>,
  deps: any[] = [],
  ...args: any[]
) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<T | null>(null);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (shouldFetch) {
        setIsLoading(true);
        try {
          const response = await serviceFn(...args); // ✅ sem signal

          setData(response);
        } catch (err: any) {
          console.error("Erro ao buscar dados:", err);
          setError(err);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchData();

    return () => {
      // nada pra abortar aqui agora
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { isLoading, data, error };
}
